import React from 'react';
import {defaultComponentDidMount, defaultComponentWillUnmount} from './basewidget';
import {postConversion,onOptionsUpdate} from './compass';
import {
  safeNumber
} from '../settings/conversions';

var size = 400;
var half = size / 2;

export default class CompassReadingComponent extends React.Component {
  constructor(props) {
    super(props);
    this.widgetLabel = '';
    this.onOptionsUpdate = onOptionsUpdate.bind(this);
    this.onOptionsUpdate(this.props.optionsBundle.getOptions());
    this.state = {
      value: {angle: NaN, safeAngle: 0, angleText: '-'}
    };
  }

  render() {
    try {
      return (
        <svg height="100%" width="100%" viewBox="100 0 200 100">
          <g transform={centerRotate(-this.state.value.safeAngle)}>
            {tenTicks}
            {fiveTicks}
            {mainDirs}
            {minorDirs}
            {isNaN(this.state.value.angle) ? undefined : needle()}
          </g>
          <text x="200" y="70" textAnchor="middle" fontSize="38" dominantBaseline="middle" stroke="none">{this.state.value.angleText}</text>
          <text x="200" y="90" textAnchor="middle" fontSize="12" dominantBaseline="middle" stroke="none">{this.widgetLabel}</text>
        </svg>
      )
    } catch (ex) {console.log(ex)}
    return (<div>safety mode</div>)
  }

  componentDidMount() {
    defaultComponentDidMount(this,undefined,postConversion);
  }

  componentWillUnmount() {
    defaultComponentWillUnmount(this);
  }
};



function centerRotate(deg) {
  return "rotate(" + deg + " " + half + " " + half + ")"
}

function create10Ticks() {
  var result = []
    for (var i = 0; i < 360; i += 10) {
    if (i % 90 != 0) {
      result.push(
        <path key={"id10-" + i} id={"id10-" + i} d={"m " + half + "," + "0 L " + half + "," + (half * 0.1)} strokeWidth="1" transform={centerRotate(i)}/>
      )
    }
  }
  return result;
}

function create5Ticks() {
  var result = []
  for (var i = 5; i < 360; i += 10) {
    if (i % 45 != 0) {
      result.push(
        <path key={"id5-" + i} id={"id5-" + i} d={"m " + half + "," + "0 L " + half + "," + (half * 0.07)} strokeWidth="1"  transform={centerRotate(i)}/>
      )
    }
  }
  return result;
}

function toMainDirText(dir, i) {
  return (
    <text id={'bearing' + i*90}
       key={'bearing' + i*90}
       x={half}
       y={0.06 * size * 0.8}
       textAnchor="middle"
       fontSize={(0.07 * size) + "px"}
       transform={centerRotate(i*90)} stroke="none">{dir}</text>
  )
}

function toMinorDirText(dir, i) {
  return (
    <text id={'bearing' + i*90+45}
       key={'bearing' + i*90+45}
       x={half}
       y={0.03 * size * 0.8}
       textAnchor="middle"
       fontSize={(0.03 * size) + "px"}
       transform={centerRotate(i*90+45)} stroke="none">{dir}</text>
  )
}

function needle() {
  return (
    <path key="needle" d="M 200,25 l 10,10 L 210,375 l -20,0 L 190,35 Z" style={{fill:'none', strokeWidth:1}}></path>
  )
}

var tenTicks = create10Ticks();
var fiveTicks = create5Ticks();
var mainDirs = ['N', 'E', 'S', 'W'].map(toMainDirText);
var minorDirs = ['NE', 'SE', 'SW', 'NW'].map(toMinorDirText);
var mainDirs = ['N', 'E', 'S', 'W'].map(toMainDirText);
var minorDirs = ['NE', 'SE', 'SW', 'NW'].map(toMinorDirText);
